import { Box, Flex } from '@chakra-ui/react';
import { format } from 'date-fns-tz';
import { isEqual } from 'lodash';

import { Condition } from 'Component/others';
import useGetBrand from 'Domain/brand/useGetBrand';
import FilterSelect from 'UiKit/filter-select';
import { TextSemiBold } from 'UiKit/typography';
import FilterYearMonthPicker from 'UiKit/filter-year-month-picker';
import { CloseIcon, PlusIcon } from 'Asset/icon';
import { targetText } from 'Const/target/text';
import { getMenuPermissions } from 'Helper/getMenuPermissions';

import { useTargetState } from 'View/target/state';

import styles from './styles.module.css';
import ButtonSolid from 'UiKit/button/buttonSolid';

const Filter = ({ t }) => {
  const { updateState } = useTargetState();
  const accessPermission = getMenuPermissions('achievement', 'target');
  const { filterState, updateFilterState, resetFilterState } = useTargetState();
  const currentDate = format(new Date(), 'yyyy-MM');

  const { brand, appliedAt } = filterState;

  const { data: brandOptions, isLoading: isLoadingBrand } = useGetBrand({ enabled: true });

  const onChangeFilter = (value) => updateFilterState({ ...value, page: 1 });
  const resetFilter = () => resetFilterState();

  const isShowClear = brand || !isEqual(format(appliedAt, 'yyyy-MM'), currentDate);

  return (
    <Flex className={styles['filter__container']} data-testid="filter__container">
      <Flex gap={'12px'}>
        <Box>
          <FilterSelect
            value={brand}
            onChange={(value) =>
              onChangeFilter({
                brand: value,
              })
            }
            placeholder={t('filter.selectBrand')}
            clearable={true}
            options={brandOptions}
            isLoading={isLoadingBrand}
            width="168px"
          />
        </Box>
        <Box>
          <FilterYearMonthPicker
            value={appliedAt}
            onChange={(value) =>
              onChangeFilter({
                appliedAt: value,
              })
            }
          />
        </Box>
        <Condition statement={isShowClear}>
          <Box className={styles['filter__clear-filter']} onClick={() => resetFilter()}>
            <CloseIcon size="18px" /> <TextSemiBold className={styles['filter__clear-filter-text']}>Clear filters</TextSemiBold>
          </Box>
        </Condition>
      </Flex>

      <Condition statement={accessPermission?.isCanCreate}>
        <ButtonSolid
          type="button"
          className={styles['filter__create-button']}
          color="var(--color-info70)"
          leftIcon={<PlusIcon width="12px" height="12px" color="var(--color-semantic-white)" />}
          onClick={() =>
            updateState({
              isOpenFormUpsert: true,
              isEditFormUpsert: false,
            })
          }
        >
          {targetText.createButton}
        </ButtonSolid>
      </Condition>
    </Flex>
  );
};

export default Filter;
